// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector(".carousel-hero-caption");
    if (!carousel) {
      return;
    }

    carousel.style.backgroundColor = "#000"; // Set background color of carousel to black

    const carouselTrack = document.querySelector(
        ".carousel-hero-caption .wp-block-group"
    );
    if (!carouselTrack) {
      return;
    }

    const carouselSlides = carouselTrack.querySelector(
        ".carousel-hero-caption .wp-block-group .wp-block-group"
    );
    if (!carouselSlides) {
      return;
    }

    const carouselIndividualSlide = carouselTrack.querySelectorAll(
        ".carousel-hero-caption .wp-block-group .wp-block-group .wp-block-cover"
    );

    // If all slides use the same background image, keep it static to avoid clone flicker.
    const backgroundImages = carouselSlides.querySelectorAll(
        ".wp-block-cover__image-background"
    );
    const uniqueBackgrounds = new Set(
        Array.from(backgroundImages)
            .map((img) => img.currentSrc || img.getAttribute("src") || "")
            .filter(Boolean)
    );
    const hasSingleBackground = uniqueBackgrounds.size <= 1;

    // Add Glide classes
    carouselTrack.classList.add("glide__track");
    carouselTrack.dataset.glideEl = "track";
    carouselSlides.classList.add("glide__slides");
    carouselIndividualSlide.forEach((item) => {
      item.classList.add("glide__slide");
      item.style.transition = "opacity 1s"; // Add transition style
    });

    // Tweak styles
    carousel.style.overflow = "hidden";
    carouselSlides.style.flexWrap = "nowrap";

    const fullWidthGlide = new Glide(".carousel-hero-caption", {
      type: hasSingleBackground ? "slider" : "carousel",
      perView: 1,
      autoplay: hasSingleBackground ? false : 3000,
      rewind: !hasSingleBackground,
      peek: 0,
      gap: 0,
      animationDuration: 10,
      swipeThreshold: 10,
    }).mount();

    // Adjust opacity of slides
    fullWidthGlide.on("move", function () {
      carouselIndividualSlide.forEach((item) => {
        item.style.opacity = 0.1;
      });
    });

    fullWidthGlide.on("move.after", function () {
      carouselIndividualSlide[fullWidthGlide.index].style.opacity = 1;
    });

    if (carouselIndividualSlide[fullWidthGlide.index]) {
      carouselIndividualSlide[fullWidthGlide.index].style.opacity = 1;
    }
  }
}

export default CarouselHeroCaption;
